import { delay } from "lodash"
import React, { useEffect, useState } from "react"

import DashboardCard from "@components/common/DashboardCard"
import { randomIntFromInterval } from "@services/util"

interface IProps {
  textList: string[]
  title: string
  randomizeRounds?: number
  millisecondsPerShuffle?: number
}


/**
 * this page shuffles given strings and shows one
 */
const ShuffleCard: React.FC<IProps> = (props: IProps) => {
  const { textList, title, randomizeRounds = 30, millisecondsPerShuffle = 30 } = props

  const [randomText, setRandomText] = useState<string>(null)
  const [randomizedLoops, setRandomizedLoops] = useState<number>(0)

  const randomizeText = () => {
    const rand = randomIntFromInterval(0, textList?.length)
    setRandomText(textList?.[rand])
  }

  // starts a new round of randomizing the texts
  const startRandomizing = () => {
    setRandomizedLoops(0)
    randomizeText()
  }

  // start randomizing, when the textlist is given
  useEffect(() => {
    startRandomizing()
  }, [textList.length])

  // loops the randomization process until randomizedRounds are overstepped
  useEffect(() => {
    if (randomizedLoops < randomizeRounds) {
      randomizeText()
      delay(setRandomizedLoops, millisecondsPerShuffle, randomizedLoops + 1)
    }
  }, [randomizedLoops])


  return <DashboardCard
    className="clickable"
    onClick={startRandomizing}
    title={title}
  >
    {randomText}
  </DashboardCard>
}

export default ShuffleCard
